import React, { FC } from 'react'
import { TFunction } from 'i18next'
import { useTranslation } from 'react-i18next'
import ErrorTemplate from '../../components/Error/ErrorTemplate'

const UnauthorizedPage: FC = () => {
    // Global
    const { t }: { t: TFunction } = useTranslation('error')

    return (
        <div className='unauthorized-page'>
            <ErrorTemplate h1={t('error-page.unauthorized.h1')} />
        </div>
    )
}

export default UnauthorizedPage
